import { render, staticRenderFns } from "./VListFlags.vue?vue&type=template&id=7a95ff2a&"
import script from "./VListFlags.vue?vue&type=script&lang=js&"
export * from "./VListFlags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports